import { IconBase, IconBaseProps } from "./IconBase";

export const ChevronDownIcon = (props: IconBaseProps) => (
  <IconBase {...props}>
    <polyline points="6 9 12 15 18 9" />
  </IconBase>
);
